import React from 'react';
import { Wrench } from 'lucide-react';

// Pièces détachées officielles du fabricant citées pour ce véhicule dans le tarif
// fournisseur. Ce ne sont pas des fiches produits : référence et désignation seules,
// sans prix ni ajout au panier.
export default function SparePartsOfficiels({ product, compact = false }) {
  const refs = product?.spare_parts_officiels || [];
  if (!refs.length) return null;

  if (compact) {
    return (
      <div>
        <p className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1.5">
          <Wrench className="w-3.5 h-3.5 text-cs-blue" /> Pièces officielles compatibles ({refs.length})
        </p>
        <div className="rounded-lg border border-gray-200 divide-y divide-gray-100 max-h-64 overflow-y-auto">
          {refs.map((p, i) => (
            <div key={`${p.reference}-${i}`} className="flex items-center gap-2 px-3 py-2">
              <span className="text-[10px] font-bold text-cs-blue bg-cs-blue/10 px-1.5 py-0.5 rounded shrink-0">{p.reference}</span>
              <span className="text-xs text-gray-700 truncate">{p.name}</span>
            </div>
          ))}
        </div>
        <p className="text-[10px] text-gray-400 mt-1.5">Liste issue du tarif officiel du fabricant — aucun produit n'est créé pour ces références.</p>
      </div>
    );
  }

  return (
    <div className="mt-16 pt-10 border-t border-gray-100">
      <div className="flex items-center gap-2 mb-1">
        <Wrench className="w-5 h-5 text-cs-blue" />
        <h2 className="font-display font-bold text-xl text-gray-900">PIÈCES COMPATIBLES</h2>
      </div>
      <p className="text-sm text-gray-500 mb-6">
        Références officielles {product.brand ? `${product.brand} ` : ''}pour ce véhicule — contactez-nous pour la disponibilité.
      </p>
      <div className="rounded-xl border border-gray-200 overflow-hidden divide-y divide-gray-100">
        {refs.map((p, i) => (
          <div key={`${p.reference}-${i}`} className="flex items-center gap-3 px-4 py-2.5 bg-white hover:bg-gray-50 transition-colors">
            <span className="text-[11px] font-bold text-cs-blue bg-cs-blue/10 px-2 py-1 rounded shrink-0">{p.reference}</span>
            <span className="text-sm text-gray-800">{p.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}